/**
 * PlanningEventEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { PlanningEventCategoryEntity } from "../PlanningEventCategoryEntity";
import { PlanningEventGroupEntity } from "../PlanningEventGroupEntity";
import { WorkPackageEntity } from "../WorkPackageEntity";
import { PlanningEventLogEntity } from "../PlanningEventLogEntity";
import { PlanningEventDependencyEntity } from "../PlanningEventDependencyEntity";
import { CalendarModification_PlanningEventEntity } from "../CalendarModification_PlanningEventEntity";
import { PlanningEventEntity } from "../PlanningEventEntity";
declare global {
    interface EntityTypeMap {
        PlanningEvent: PlanningEventEntity;
    }
}
export abstract class PlanningEventGeneratedEntity extends BaseEntity {
    public abstract planningEventId: string;
    public abstract templateId: string | null;
    public abstract text: string;
    public abstract creationDate: Date;
    public abstract startDate: Date;
    public abstract endDate: Date | null;
    public abstract progress: number;
    public abstract durationCalendarDays: number | null;
    public abstract durationWorkingDays: number | null;
    public abstract notes: string | null;
    public abstract status: string | null;
    public abstract isMilestone: boolean;
    public abstract project: ProjectEntity;
    public abstract category: PlanningEventCategoryEntity | null;
    public abstract group: PlanningEventGroupEntity | null;
    public abstract workPackage: WorkPackageEntity | null;
    public abstract readonly planningEventLogs: ReadonlyArray<PlanningEventLogEntity>;
    public abstract readonly successorDependencies: ReadonlyArray<PlanningEventDependencyEntity>;
    public abstract readonly predecessorDependencies: ReadonlyArray<PlanningEventDependencyEntity>;
    public abstract readonly calendarModificationPlanningEventRelations: ReadonlyArray<CalendarModification_PlanningEventEntity>;
}
